import {
  EAutoDiagDeviceInfoEnergyManager,
  EAutoDiagDiagnosticTestResult,
} from "@/types/backoffice/dto/autodiag/auto-diag-dto.ts";

const autoDiagLocale = {
  autoDiag: {
    realtimeDiagnostic: "Diagnostic en temps réel",
    warningMultipleDiags: "Il ne faut pas lancer plusieurs DIAG en même temps. Il faut attendre la fin du 1er",
    warningPreTest:
      'Avant tout diagnostic, s\'assurer que tous les disjoncteurs au tableau électrique sont sur ON (ou en position Haute) et cliquer sur "Synchroniser programmation MyV"',
    techInstructionsPreBtn: "Si le problème est non résolu après le diagnostic, ",
    techInstructionsBtn: "merci de saisir les consignes pour le technicien",
    syncMyVProgrammingButton: "Synchroniser programmation MyV",
    diagnostic: {
      headers: {
        deviceName: "Nom de l'appareil",
        result: "Résultat",
        date: "Date",
        energyManager: "Gestionnaire d'énergie",
        myvProgram: "Consigne",
        synchronization: "Synchronisation",
        launchDiag: "Lancer diag",
        hint: "Aide",
        actions: "Actions",
      },
      test: {
        [EAutoDiagDiagnosticTestResult.OK]: "Pilotage OK",
        [EAutoDiagDiagnosticTestResult.NOK_NO_POWER]: "Appareil: Conso faible",
        [EAutoDiagDiagnosticTestResult.NOK_NO_MODULATION]: "Appareil : Échec de pilotage",
        [EAutoDiagDiagnosticTestResult.NOK_UNREACHABLE]: "Module: Échec de connexion",
        [EAutoDiagDiagnosticTestResult.NOK_DEVICE_UNKNOWN]: "Module: Échec de connexion",
        [EAutoDiagDiagnosticTestResult.FAILED_BACKEND]: "Échec Infra Voltalis",
      },
      energyManager: {
        [EAutoDiagDeviceInfoEnergyManager.HAS_ENERGY_MANAGER]: "Détecté",
        [EAutoDiagDeviceInfoEnergyManager.NO_ENERGY_MANAGER]: "Non détecté",
        [EAutoDiagDeviceInfoEnergyManager.ERROR_INFRA_VOLTALIS]: "Échec Infra Voltalis",
      },
      conformity: {
        notConform: "Non conforme",
        conform: "Conforme",
        error: "Échec Infra Voltalis",
      },
    },
  },
};

export type AutoDiagLocale = typeof autoDiagLocale;
export default autoDiagLocale;
